<template>
  <div class="gp-main-body-content">
    <div class="container">
      <div class="row">
        <GpTabs :verticle="true" @tabChange="onTabChangeHandler" class="flex-column flex-md-row mt-5" :customNav="true" :customBody="true">
          <template v-slot:GpTabsNav="{activeIndex, handler}">
            <GpTabsNav class="col-xl-3 col-lg-4 col-md-4 col-sm-12 p-0 pb-2">
              <GpTab
                to="#"
                :index="ind"
                :activeIndex="activeIndex"
                @click="handler"
                v-for="(item, ind) in faqs"
                :key="ind"
              >
                <p class="d-flex align-items-center">
                  <span>{{item.title}}</span>
                </p>
              </GpTab>
            </GpTabsNav>
          </template>

          <!-- List -->
          <template v-slot:GpTabsContent="{activeIndex, animate}">
            <GpTabsContent class="col-xl-9 col-lg-8 col-md-8 col-sm-12">
              <GpTabContent
                
                name="Account"
                :animate="animate"
                :index="ind"
                :activeIndex="activeIndex"
                v-for="(item, ind) in faqs"
                :key="ind"
              >
                <div class="row">
                  <div class="col-12">
                    <div class="col-12">
                      <div class="px-0 px-md-6 pt-3 pb-6">
                        <h2 class="typo-h6 mb-4">{{item.title}}</h2>
                        <GpAccordion :item="faq" v-for="(faq, i) in item.items" :key="i" />
                      </div>
                    </div>
                  </div>
                </div>
              </GpTabContent>
            </GpTabsContent>
          </template>
        </GpTabs>
      </div>
    </div>
  </div>
</template>

<script>
import GpTabs, { GpTab, GpTabContent, GpTabsNav, GpTabsContent } from "@/core/shared/GpTabs";
import { GpAccordion } from "@/core/shared/GpForms";
export default {
  name: "FAQs",
  components: {
    GpTabs,
    GpTab,
    GpTabContent,
    GpTabsContent,
    GpTabsNav,
    GpAccordion
  },
  data() {
    return {};
  },
  computed: {
    faqs() {
      return [
        {
          title: this.$t("pricing.started"),
          items: [
            {
              title: this.$t("pricing.question1"),
              content: this.$t("pricing.answer1")
            },
            {
              title: this.$t("pricing.question11"),
              content: this.$t("pricing.answer11")
            },
            {
              title: this.$t("pricing.question12"),
              content: this.$t("pricing.answer12")
            }
          ]
        },
        {
          title: this.$t("pricing.pricingTrial"),
          items: [
            {
              title: this.$t("pricing.question22"),
              content: this.$t("pricing.answer22")
            },
            {
              title: this.$t("pricing.question23"),
              content: this.$t("pricing.answer23")
            },
            {
              title: this.$t("pricing.question24"),
              content: this.$t("pricing.answer24")
            },
            {
              title: this.$t("pricing.question25"),
              content: this.$t("pricing.answer25")
            }
          ]
        },
        {
          title: this.$t("pricing.highlight"),
          items: [
            {
              title: this.$t("pricing.question13"),
              content: this.$t("pricing.answer13")
            },
            {
              title: this.$t("pricing.question14"),
              content: this.$t("pricing.answer14")
            }
          ]
        },
        {
          title: this.$t("pricing.func"),
          items: [
            {
              title: this.$t("pricing.question15"),
              content: this.$t("pricing.answer15")
            },
            {
              title: this.$t("pricing.question16"),
              content: this.$t("pricing.answer16")
            },
            {
              title: this.$t("pricing.question17"),
              content: this.$t("pricing.answer17")
            },
            {
              title: this.$t("pricing.question18"),
              content: this.$t("pricing.answer18")
            },
            {
              title: this.$t("pricing.question19"),
              content: this.$t("pricing.answer19")
            },
            {
              title: this.$t("pricing.question20"),
              content: this.$t("pricing.answer20")
            }
          ]
        },
        // {
        //   title: this.$t("pricing.other"),
        //   items: [
        //     {
        //       title: this.$t("pricing.question21"),
        //       content: this.$t("pricing.answer21")
        //     }
        //   ]
        // }
      ];
    }
  },
  methods: {
    onTabChangeHandler() {}
  }
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
